import moment from "moment-timezone";

import { convertToUserTimezone, getUserTimezone } from "@helpers/timezone";

export const formatWalletTxDateTime = (createdAt) =>
  convertToUserTimezone(createdAt, "YYYY-MM-DD HH:mm:ss");

/**
 * Calendar day (YYYY-MM-DD) in the user's timezone — matches how tx timestamps are shown.
 * @param {string | number | Date} createdAt
 * @returns {string | null}
 */
export const getWalletTxCalendarDayKey = (createdAt) => {
  if (createdAt == null || createdAt === "") return null;

  const tz = getUserTimezone();
  const strict = moment.utc(createdAt, "YYYY-MM-DD HH:mm:ss", true);
  const parsed = strict.isValid() ? strict : moment.utc(createdAt);

  if (!parsed.isValid()) return null;

  return parsed.tz(tz).format("YYYY-MM-DD");
};

const isWalletTxBonusEmpty = (bonus) =>
  bonus == null ||
  bonus === "" ||
  bonus === "—" ||
  bonus === "-" ||
  bonus === "–";

export const formatWalletTxBonusDisplay = (bonus, currency) => {
  const cur =
    currency != null && String(currency).trim() !== ""
      ? String(currency).trim()
      : "";
  const zero = cur ? `0 ${cur}` : "0";

  if (isWalletTxBonusEmpty(bonus)) return zero;
  if (bonus === 0 || bonus === "0") return zero;
  return bonus;
};
